import { a } from "../utils";
export interface ArtItemsObj {
    q: { search?: string, page: number, pageSize: number },
    ids: number[],
}
export const setArtItemsIds = (obj: ArtItemsObj) => a({ type: "SET_ART_ITEMS_IDS", obj });